import { styled } from '@linaria/react'
import { Link } from '@tanstack/router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Icon from '../icon'

const Container = styled.div`
  transition: all 0.2s ease-in-out;
  overflow: hidden;
  .theme-dark & {
    border-bottom: 1px solid #1f223c;
  }
  .theme-light & {
    border-bottom: 1px solid #f5f6f9;
  }
`

const Head = styled.div`
  padding: 10px 20px;
  svg {
    transition: all 0.2s ease-in-out;
  }
  span {
    font-size: 12px;
    text-transform: uppercase;
    color: var(--txt);
  }
  img {
    max-width: 25px;
    max-height: 25px;
  }
`

const DropdownItem = styled.div`
  padding: 8px 0;
  &:last-child {
    border: none;
  }
  span {
    font-size: 12px;
    text-transform: uppercase;
    color: var(--txt);
  }
  div {
    width: 40px;
  }
  svg {
    width: 25px;
    height: 25px;

    fill: var(--txt);
  }
  &.active {
    span {
      color: #46aef7;
    }
    svg {
      fill: #46aef7;
    }
  }
`

const DropdownContainer = styled.div`
  padding: 6px 0 6px 20px;
  background-color: var(--secondary);
`

const TabLabel = styled.p`
  color: var(--highlight);
  margin-left: 10px;
  margin-right: 10px;
`

type SportsDrawerTabsProps = {
  closeProfileDrawer: () => void
}

const SportsDrawerTabs = ({ closeProfileDrawer }: SportsDrawerTabsProps) => {
  const { t, i18n: { language } } = useTranslation('drawer')
  const [isOpen, setIsOpen] = useState(false)
  const sportsLinks = [
    {
      to: language === 'zh' ? 'sports/im' : '/sports/bti',
      label: language === 'zh' ? t('more-livestreams') : t('best-odds'),
    },
    {
      to: language === 'zh' ? 'sports/bti' : '/sports',
      label: language === 'zh' ? t('best-odds') : t('bet-and-win'),
    },
    {
      to: language === 'zh' ? '/sports' : '/sports/im',
      label: language === 'zh' ? t('bet-and-win') : t('more-livestreams'),
    },
  ]

  return (
    <Container
      style={{
        height: isOpen ? sportsLinks.length * 40 + 56 : '39px',
      }}>
      <Head
        className="flx-btw-ctr"
        onClick={() => setIsOpen(prev => (prev ? false : true))}>
        <div className="flx-str-ctr">
          <TabLabel>{t('sports-betting')}</TabLabel>
        </div>
        <Icon
          id="triangle-down"
          width="16"
          height="10"
          fill="#46aef7"
          style={{ transform: `rotate(${isOpen ? '-180' : '0'}deg)` }}
        />
      </Head>
      <DropdownContainer>
        {sportsLinks.map((prop, key) => (
          <Link key={key} to={prop.to} activeOptions={{ exact: true }}>
            {({ isActive }) => (
              <DropdownItem
                className={`flx-str-ctr ${isActive ? 'active' : ''}`}
                onClick={closeProfileDrawer}>
                <TabLabel>{prop.label}</TabLabel>
              </DropdownItem>
            )}
          </Link>
        ))}
      </DropdownContainer>
    </Container>
  )
}

export default SportsDrawerTabs
